import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTransferPricingPeriodSelection } from '../transfer-pricing/policy/types';
import { RootfiAccountMapping } from './types';

export function useAccountMappingDataSWR(
  corporation_id: number | null,
  policyId?: string,
  period?: TTransferPricingPeriodSelection
) {
  const queryString = new URLSearchParams();

  if (corporation_id && corporation_id !== -1) {
    queryString.append('corporationId', corporation_id.toString());
  }

  if (policyId) {
    queryString.append('policyId', policyId);
  }

  if (period?.periodStart && (period.periodType || period.periodEnd)) {
    queryString.append('periodStart', period.periodStart);

    if (period.periodType) {
      queryString.append('periodType', period.periodType);
    } else if (period.periodEnd) {
      queryString.append('periodEnd', period.periodEnd);
    }
  }

  const URL =
    corporation_id && corporation_id !== -1
      ? `transfer-pricing/account-mapping?${queryString.toString()}`
      : null;

  const {
    data: rawData,
    error,
    mutate,
  }: {
    data?: { accountMappings: RootfiAccountMapping[]; count: number };
    error: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  // Extract accountMappings array to maintain backward compatibility
  const data = rawData?.accountMappings;

  return {
    data,
    error,
    mutate,
  };
}
